import {
	// FiGithub,
	// FiTwitter,
	FiLinkedin,
	// FiGlobe,
	FiYoutube,
} from 'react-icons/fi';
import AppFooterCopyright from './AppFooterCopyright';
import { useI18n } from '../../context/I18nContext';

const socialLinks = [
	// {
	// 	id: 1,
	// 	icon: <FiGlobe />,
	// 	url: 'https://www.stoman.me/',
	// },
	// {
	// 	id: 2,
	// 	icon: <FiGithub />,
	// 	url: 'https://github.com/realstoman',
	// },
	{
		id: 4,
		icon: <FiLinkedin />,
		url: 'https://www.linkedin.com/in/ibrahim-akg%C3%BCl-457995178/',
	},
	{
		id: 5,
		icon: <FiYoutube />,
		url: 'https://www.youtube.com/channel/UCn-VCGZJnrr5Hicn0px3kjA',
	},
];

const AppFooter = () => {
    const { t } = useI18n();
	return (
		<div className="container mx-auto">
			<div className="pt-20 sm:pt-30 pb-8 mt-20 border-t-2 border-primary-light dark:border-secondary-dark">
				{/* Footer social links */}
				<div className="font-general-regular flex flex-col justify-center items-center mb-12 sm:mb-28">
					<p className="text-3xl sm:text-4xl text-primary-dark dark:text-primary-light mb-5">{t('followMe')}</p>
					<ul className="flex gap-4 sm:gap-8">
						{socialLinks.map((link) => (
							<a
								href={link.url}
								target="__blank"
								key={link.id}
								className="text-gray-400 hover:text-brand-500 dark:hover:text-brand-400 cursor-pointer rounded-xl bg-primary-light dark:bg-ternary-dark shadow-clay-sm dark:shadow-clay-dark-sm p-4 duration-300"
							>
								<i className="text-xl sm:text-2xl md:text-3xl">
									{link.icon}
								</i>
							</a>
						))}
					</ul>
				</div>

				<AppFooterCopyright />
			</div>
		</div>
	);
};

export default AppFooter;
